/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { string, node } from 'prop-types'
import './Footer.css'

import AMPNORTON from '../../../assets/images/norton-seal-public-site.png'

/* 
 * <MicrositeFooter />
 * Renders footer.
 */

export const MicrositeFooter = (props) => {

    let nortonImage = AMPNORTON
    if(props && props.nortonLogo) {
        nortonImage = props.nortonLogo
    }

    const [year, setYear] = useState(null)

    useEffect(() => {
      const currentYear = new Date().getFullYear()
      setYear(currentYear)
    }, [])

    const openNortonPopup = (event) => {
      const popupName = 'Norton Secured Seal'
      const targetUrl = event.currentTarget.getAttribute('href') || '/'
      const params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=580,height=500,left=-1000,top=-1000`
      window.open(targetUrl, popupName, params)
    }

    return (
        <footer className="footer u-decoBorderLight">
            <div className="ms-footerPrint u-bgColorLight u-paddingBottom10gu">
            <div className="ms-printLeftContainer u-sizeConstrained u-flex">
                <div className="u-sizeFill u-flex u-sm-flexCol u-md-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart u-md-flexAlignItemsStart u-marginLeftM1gu u-marginBottom2gu">
                    <div className="ms-listItem u-marginVert3gu">
                        <p className="u-padding1gu">
                            <a className="Link Link--currentColor" href="/legal/disclosures" >Corporate entities and important disclosures</a>
                        </p>
                    </div>
                    <div className="u-sm-hidden u-md-hidden u-decoBorderLight u-decoBorderResetTBL footer-border u-marginRight2gu"></div>
                    <div className="ms-listItem u-marginVert3gu">
                        <p className="u-padding1gu">
                            <a className="Link Link--currentColor" href="/legal/website-rules" >Website rules, regulations and disclaimers</a>
                        </p>
                    </div>
                    <div className="u-sm-hidden u-md-hidden u-decoBorderLight u-decoBorderResetTBL footer-border u-marginRight2gu"></div>
                    <div className="ms-listItem u-marginVert3gu">
                        <p className="u-padding1gu">
                            <a className="Link Link--currentColor" href="/privacy-security-fraud/online-security-guarantee" >Online security guarantee</a>
                        </p>
                    </div>
                    <div className="u-sm-hidden u-md-hidden u-decoBorderLight u-decoBorderResetTBL footer-border u-marginRight2gu"></div>
                    <div className="ms-listItem u-marginVert3gu">
                        <p className="u-padding1gu">
                            <a className="Link Link--currentColor" href="/privacy-security-fraud/fraud-reporting/email-fraud" >About email fraud</a>
                        </p>
                    </div>
                    <div className="u-sm-hidden u-md-hidden u-decoBorderLight u-decoBorderResetTBL footer-border u-marginRight2gu"></div>
                    <div className="ms-listItem u-marginVert3gu">
                        <p className="u-padding1gu">
                            <a className="Link Link--currentColor" href="/legal/client-relationship-summary" >Client Relationship Summary</a>
                        </p>
                    </div>
                </div>
                <div className="u-flex u-flexJustifyEnd u-block u-sm-hidden">
                <div className="norton-seal">
                    <a href="https://seal.digicert.com/seals/popup/?tag=5aDFDJql&url=www.ameriprise.com&lang=en&cbr=1621017956698" className="amp-nortonPopup u-block" rel="external" target="_blank" onClick={ (event)=>{ event.preventDefault(); return openNortonPopup(event) }}>
                     <img src={ nortonImage } alt="Norton Secured, logo" />
                    </a>
                </div>
                </div>
            </div>
            <div className="u-sizeConstrained">
                <p className="ms-userAgreeTerms u-textColorLight u-marginBottom6gu">Users of this site agree to be bound by the terms of the Ameriprise Financial Website Rules and Regulations.</p>
                <p className="u-textColorLight">© <span className="msCurrentYear">{ year }</span> Ameriprise Financial, Inc. All rights reserved.</p>
            </div>
            </div>
        </footer>
    )
}

MicrositeFooter.propTypes = {
  className: string,
  children: node,
  nortonLogo: string
}
  
MicrositeFooter.defaultProps = {
  children: null,
  className: '',
  nortonLogo: ''
}